import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import cx from 'classnames';
import * as List from '@/shared/ui/List';
import { Settings } from 'lucide-react';
import Drawer from '@/shared/ui/Drawer';
import { getSettingsLink } from '@/shared/constants/links';
import { useNavigation } from '@/processes/Router';
import s from './DashboardActionsMobile.module.scss';
import Button from '@/shared/ui/Button';
import { SwipeHead } from '@/shared/ui/SwipeList';

type DashboardActionsMobileProps = {
  className?: string;
}

const DashboardActionsMobile = (props: DashboardActionsMobileProps) => {
  const { 
    className = '',
  } = props;
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const { coin, navigate, query } = useNavigation();

  const handleShowDrawer = () => { setIsOpen(true); }
  const handleHideDrawer = () => { setIsOpen(false); }

  const dashboardLinks = [
    {
      id: 'payout',
      title: 'header.payout',
      link: getSettingsLink(coin, 'payout', query),
    },
    {
      id: 'watchers',
      title: 'header.watchers',
      link: getSettingsLink(coin, 'watchers', query),
    },
  ];

  const handleLinkClick = (link: string) => {
    navigate(link);
    handleHideDrawer();
  }

  return (
    <>  
      <Button 
        fw="normal"
        colorSchema="secondary" 
        justify="between"
        type="button"
        aria-label={intl.formatMessage({ id: 'header.actions' })}
        className={cx(s.toggler, className)}
        onClick={handleShowDrawer}
        aria-expanded={isOpen}
        aria-controls="dashboard-actions-menu"
      >
        <Settings className="size-4"/>
      </Button>

      <Drawer
        open={isOpen}
        onInteractOutside={handleHideDrawer}
      >
        <SwipeHead
          title={intl.formatMessage({ id: 'header.actions'})}
          action={<FormattedMessage id="header.cancel"/>}
          onDismiss={handleHideDrawer}
        />
        <List.Root>
          {dashboardLinks.map(({ id, title, link }) => {
            return (
              <List.Item key={id} mb="xs" theme='secondary' className='' onClick={() => handleLinkClick(link)}>
                <FormattedMessage id={title}/>
              </List.Item>
            )
          })}
        </List.Root>
      </Drawer>
    </>  
  );
}

export default DashboardActionsMobile;

